<template>
    <div v-if="notificationMessageComputed !== '' && show !== false" class="gz-notification-static">
        <div class="gz-notification-static__message">
            <p>{{ notificationMessageComputed }}</p>
        </div>
        
        <section class="gz-notification-static__actions">
            <span
                @click="openNotificationModal($store.getters['addressLocation'], $route.params.id)" 
                class="icon-pencil gz-notification-static__actions__item gz-notification-static__actions__item_edit"></span>
        </section>
    </div>
</template>

<script>
import openNotificationModal from '@/mixins/ui/openNotificationModal'

export default {
    name: 'BaseStaticNotification',
    
    mixins: [openNotificationModal],
    props: {
        message: {
            type: [String, Array],
            default: ''
        }
    },
    data() {
        return {
            notificationMessage: this.message,
            show: true
        }
    },
    computed: {
        notificationMessageComputed() {
            return this.$store.getters['notificationStaticMessage']
        }
    }
}
</script>